import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export interface RecentMemory {
  id: string;
  title: string | null;
  created_at: string;
}

export function useRecentMemories(limit = 50) {
  const query = useQuery({
    queryKey: ["recent-memories", limit],
    staleTime: 30_000,
    queryFn: async () => {
      const { data } = await supabase
        .from("memories")
        .select("id, title, created_at")
        .order("created_at", { ascending: false })
        .limit(limit);
      return (data ?? []) as RecentMemory[];
    },
  });

  return {
    data: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error as Error | null,
    refetch: query.refetch,
  };
}
